import React, { useEffect, useState, useRef } from "react";
import {
  Send,
  MessageCircleMore,
  MessageCircle,
  ChevronRight,
} from "lucide-react";
import { Tooltip, Input } from "antd";
import intl from "react-intl-universal";
import Draggable from "react-draggable"; // 添加 react-draggable 导入

import { getAiAssistantList, getAiAssistantAnswer } from "@/api/login";
import logo from "@/assets/image/logo.png";
import aipng from "@/assets/image/ai.png";
import aiImg from "@/assets/image/ai.gif";
import sendImg from "@/assets/image/send.png";
import mascotImg from "@/assets/image/mascot.png";
import styles from "./index.module.scss";

const { TextArea } = Input;
const QaA = (props) => {
  const { userName, userId } = props;

  const [messages, setMessages] = useState<any>([
    {
      role: "assistant",
      content:
        "Hey — I am the partner collab assistant. Pick a question below, or you may submit your inquiry via the chat interface.",
    },
    {
      role: "userQ",
    },
  ]);
  const [questionList, setQuestionList] = useState<any>([]);
  const [text, setText] = useState<string>("");
  const messagesEndRef = useRef(null); // 添加 ref 引用
  const [typingLoading, setTypingLoading] = useState<boolean>(false);
  const getQuestionList = async () => {
    const res = await getAiAssistantList({
      page: 1,
      size: 100,
    });
    if (res.code === 200) {
      setQuestionList(res.data.records);
    }
  };

  useEffect(() => {
    getQuestionList();
  }, []);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = 999999999999;
    }
  }, [messages]); // 每当 messages 更新时执行

  const sendMessage = (msg) => {
    if (typingLoading) {
      return;
    }
    setMessages([...messages, { role: "user", content: msg }]);
    setText("");
    setTimeout(() => {
      setTypingLoading(true);
      messagesEndRef.current.scrollTop = 999999999999;
    }, 100);
    setTimeout(() => {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "assistant",
          content: (
            <>
              Sorry — I am getting far more questions than I can handle right
              now, and my brainpower is running out. Rather than risk giving you
              a half-right answer, please send this one to our human team on
              WhatsApp — a partner manager will pick it up for you.
              <div
                className={styles.chatWhatsApp}
                onClick={() => {
                  window.open("https://wa.me/16572933199", "_blank");
                }}
              >
                <MessageCircle size={14} />
                Chat on WhatsApp
              </div>
              <div
                className={styles.backToQuestion}
                onClick={() => {
                  setMessages((prevMessagesnew) => [
                    ...prevMessagesnew,
                    {
                      role: "userQ",
                    },
                  ]);
                }}
              >
                Back to the question list
              </div>
            </>
          ),
        },
      ]);
      setTypingLoading(false);
    }, 2000);
  };

  const getAnswer = async (id, item) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "user",
        content: item.question,
      },
    ]);
    setTimeout(async () => {
      setTypingLoading(true);
      try {
        const res = await getAiAssistantAnswer(id);
        if (res.code === 200) {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              role: "assistant",
              type: res.data.type,
              content: res.data.answer,
            },
          ]);
          setTypingLoading(false);
        }
      } catch (error) {
        setTypingLoading(false);
      }
    }, 300);
  };

  const msgTooltip = () => {
    return (
      <div className={styles.msgListView}>
        <div className={styles.header}>
          <img className={styles.mascot} src={mascotImg} alt="" />
          <div className={styles.name}>
            <div className={styles.nameTitle}>9five Assistant</div>
            <div className={styles.nameDesc}>
              <i />
              Online · replies instantly
            </div>
          </div>
        </div>
        <div className={styles.msgListViewTop} ref={messagesEndRef}>
          {messages.map((item, index) => {
            if (item.role === "user") {
              return (
                <div key={index} className={styles.listUser}>
                  <div className={styles.msgBox}>{item.content}</div>
                </div>
              );
            }
            if (item.role === "userQ") {
              return (
                <div key={index} className={styles.listUser}>
                  <div className={styles.question}>
                    <div className={styles.questionTitle}>Frequently asked</div>
                    {questionList.map((item) => {
                      return (
                        <div
                          key={item.id}
                          className={styles.questionItem}
                          onClick={() => {
                            getAnswer(item.id, item);
                          }}
                        >
                          <span>{item.question}</span>
                          <ChevronRight size={12} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }
            if (item.role === "assistant") {
              return (
                <div key={index} className={styles.listAssistant}>
                  <img src={mascotImg} alt="" />
                  <div className={styles.msgBox}>
                    {item.type === "IMG" ? (
                      <img
                        className={styles.contentimg}
                        src={item.content}
                        alt=""
                        onClick={() => {
                          window.open(item.content, "_blank");
                        }}
                      />
                    ) : item.type === "VIDEO" ? (
                      <video
                        className={styles.contentvideo}
                        src={item.content}
                        controls
                      />
                    ) : (
                      item.content
                    )}
                  </div>
                </div>
              );
            }
          })}
          {typingLoading && (
            <div className={styles.listAssistant}>
              <img src={mascotImg} alt="" />
              <div className={styles.typBox}>
                <span>
                  <i />
                  <i />
                  <i />
                </span>
              </div>
            </div>
          )}
        </div>
        <div className={styles.msgListText}>
          <div className={styles.textArea}>
            <Input
              placeholder={intl.get("xunfei_placeholder")}
              onChange={(e) => {
                setText(e.target.value);
              }}
              className={styles.input}
              value={text}
              onPressEnter={(event) => {
                if (event.key === "Enter" && event.shiftKey) {
                  setText((prevText) => prevText + "\n");
                  return event.preventDefault(); // 阻止默认行为
                }
                if (!text) {
                  return;
                }
                if (event.key === "Enter") {
                  sendMessage(text);
                  setText("");
                  event.preventDefault();
                }
              }}
            />
            <div className={styles.sendIcon}>
              <Send
                size={12}
                onClick={() => {
                  if (!text) {
                    return;
                  }
                  sendMessage(text);
                }}
              />
            </div>
          </div>

          <div
            className={styles.send}
            onClick={() => {
              window.open("https://wa.me/16572933199", "_blank");
            }}
          >
            <MessageCircleMore size={14} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Draggable>
      <div className={styles.contentContainer} id="msgBox">
        <Tooltip
          title={msgTooltip}
          getPopupContainer={() => document.querySelector(`#msgBox`)}
          trigger="click"
          placement="leftTop"
          color="#fff"
        >
          <img src={mascotImg} alt="" />
        </Tooltip>
        <div className={styles.dto} />
      </div>
    </Draggable>
  );
};

export default QaA;
